import JshModule from '@core/scripts/helper/jsh-module';

function initLinkParameterModules() {

  const appendUrlParameterToLink = (item) => (e) => {
    if (item.dataset.cpUrlQueryParams) {
      const separator = item.href.includes('?') ? '&' : '?';
      item.href = item.href + separator + item.dataset.cpUrlQueryParams;
      item.dataset.cpUrlQueryParams = '';
    }
  };

  do {
    const {moduleScope} = JshModule('teaser/teaser-links');

    const allTeaserLinksWithParams = moduleScope.querySelectorAll('a[data-cp-url-query-params]');

    allTeaserLinksWithParams.forEach((item) => {
      ['click', 'auxclick', 'focus'].forEach((eventname) => {
        item.addEventListener(eventname, appendUrlParameterToLink(item));
      });
    });

  } while (document.querySelector('[jsh-module="teaser/teaser-links"]') !== null);
}

window.addEventListener('DOMContentLoaded', initLinkParameterModules);
